import React, { useEffect, useState } from "react";
import "./style.css";
import AOS from "aos";
import "aos/dist/aos.css";

const AboutUs = () => {
  const [lang, setLang] = useState("En");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("language") === "En") {
      setLang("En");
    } else if (localStorage.getItem("language") === "Fr") {
      setLang("Fr");
    }
  }, []);
  return (
    <>
      <div class="bg-img">
        <div class="container">
          <div class="cover-title">
            <h1>{lang === "Fr" ? `À propos de nous` : `About us`}</h1>
          </div>
        </div>
      </div>
      <div class="section-empty">
        <div class="container content">
          <div class="row">
            <h3
              style={{
                color: "#c79e45",
                transform: "translateY(-30px)",
              }}
            >
              {lang === "Fr"
                ? `UN MESSAGE DE NOTRE FONDATEUR ET CHEF DE LA
DIRECTION, M. SIDI SHAHID.`
                : `A Message from our Founder and Chief Executive
                            Officer, Mr. Sidi Shahid.`}
            </h3>
            <div class="col-md-4 col-sm-12">
              <p className="about-text">
                {lang === "Fr"
                  ? `Merci beaucoup de l’intérêt que vous portez à Gold Bar
International. Bien que nous soyons une nouvelle
entreprise sur le marché, nous travaillons en arrière-plan
depuis mars 2018, lorsque j’ai fondé notre société à
Londres. Nous avons assemblé l’infrastructure qui nous
permettra de servir les investisseurs aurifères
internationaux grâce à une collaboration unique avec plus
de trente propriétaires de mines d’or en Afrique. Nous
offrons un approvisionnement fiable, une qualité garantie
et des prix économiques pour nos investisseurs
institutionnels et importants.`
                  : `Thank you so much for your interest in Gold Bar
                                International. While we are a new company in the
                                market, we have been working in the background
                                since March of 2018 when I founded our company
                                in London. We have assembled the infrastructure
                                that will allow us to serve international gold
                                investors via a unique collaboration with over
                                thirty gold mine owners in Africa. We offer
                                dependable supply, guaranteed quality, and
                                economic pricing for our institutional and large
                                investors.`}
              </p>
              <ul class="fa-ul about-list">
                <li>
                  <i class="fa-li fa fa-square"></i>
                  {lang === "Fr"
                    ? `Le commerce de l’or en Asie du Sud-Est et au Moyen-Orient est un objectif majeur pour ma famille depuis plus de 100 ans.`
                    : `Gold
                                    trading in Southeast Asia and the Middle
                                    East has been a major focus for my family
                                    for over 100 years`}
                </li>
                <li>
                  <i class="fa-li fa fa-square"></i>
                  {lang === "Fr"
                    ? `Cette entreprise est proche et chère à mon cœur pour plusieurs raisons à ce moment particulier de ma vie.`
                    : `This
                                    business is near and dear to my heart for
                                    several reasons at this particular time in
                                    my life`}
                </li>
                <li>
                  <i class="fa-li fa fa-square"></i>
                  {lang === "Fr"
                    ? `En plus de faire partie de l’héritage de ma famille, je me sens très proche du peuple africain qui a longtemps souffert de l’exploitation étrangère.`
                    : `In
                                    addition to being part of my family’s
                                    heritage, I feel very close to the African
                                    people that have long suffered through
                                    foreign exploitation`}
                </li>
                <li>
                  <i class="fa-li fa fa-square"></i>
                  {lang === "Fr"
                    ? `Une partie intégrante de ce que nous faisons sera d’améliorer la vie de ceux qui travaillent dans les mines, de leurs familles et de leurs
communautés.`
                    : `In An
                                    integral part of what we do will be to
                                    enhance the lives of those who work in the
                                    mines, their families, and their communities`}
                </li>
              </ul>
            </div>
            <div class="col-md-4 col-sm-6">
              <a class="img-box lightbox row-8" data-aos="zoom-in">
                <img
                  src={require("../../Assets/about-us-image1.jpg")}
                  alt=""
                  id="about-us-image2"
                  // style="margin-top: -1px;"
                />
              </a>
              <hr class="space m" />
              <div class="advs-box advs-box-side-icon">
                {/* <div class="icon-box">
                                    <i
                                        class="fa fa-medkit icon anima"
                                        style="position: relative; transition-duration: 500ms; animation-duration: 500ms; transition-timing-function: ease; transition-delay: 0ms;"
                                    ></i>
                                </div> */}
                <div class="caption-box">
                  <p>
                    {lang === "Fr"
                      ? `Je me suis engagé à faire don de 2,5% de nos bénéfices annuels pour des logements locaux, des écoles, des installations médicales et d’autres
ressources afin d’améliorer la qualité de vie de ces Africains. En outre, avec notre filiale de ressources financières, Our Bank, nous investirons
activement dans des entreprises commerciales en Afrique pour stimuler le développement économique, créer des emplois et améliorer le mode de
vie durable.

Nous sommes une société privée qui se concentre sur les ventes au comptant à partir des stocks de maisons ainsi que sur les contrats de
production pluriannuels.

Bien que nous soyons basés à Londres, nous avons des bureaux avec du personnel de soutien sur les cinq continents. Un service discret et individuel
et un niveau d’intégrité inégalé sont les caractéristiques de notre marque.`
                      : `I have committed to donate 2.5% of our
                                        annual profits for local housing,
                                        schools, medical facilities, and other
                                        resources to improve the quality of life
                                        for these Africans. Additionally, with
                                        our financial resource affiliate, Our
                                        Bank, we will actively invest in
                                        commercial ventures in Africa to
                                        stimulate economic development, to
                                        create jobs, and to provide an improved
                                        sustainable lifestyle. We are a private
                                        company that focuses on spot sales from
                                        house inventories as well as multi-year
                                        production contracts. While we are based
                                        in London, we have offices with support
                                        staff on five continents. Discrete,
                                        one-on-one service and an unmatched
                                        level of integrity are the hallmarks of
                                        our brand.`}
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <a class="img-box lightbox row-8" data-aos="zoom-in">
                <img
                  src={require("../../Assets/about-us-image2.jpg")}
                  alt=""
                  id="about-us-image2"
                  // style="margin-top: -1px;"
                />
              </a>
              <hr class="space m" />
              <div class="advs-box advs-box-side-icon">
                {/* <div class="icon-box">
                                    <i
                                        class="fa fa-road icon anima"
                                        style="position: relative; transition-duration: 500ms; animation-duration: 500ms; transition-timing-function: ease; transition-delay: 0ms;"
                                    ></i>
                                </div> */}
                <div class="caption-box">
                  <p>
                    {lang === "Fr"
                      ? `C’est mon opinion que les valorisations de l’or connaîtront une vitalité continue malgré des volumes plus
faibles en raison de la complexité croissante de notre monde Covid-19 et post-Covid 2021. Les volatilités
politiques et économiques ont historiquement stimulé le marché de l’or et notre monde semble destiné à
connaître ces instabilités dans un avenir prévisible.

Je crois que les systèmes de paiement numériques, les crypto-monnaies et d’autres structures de paiement
non traditionnelles auront en fait d’importantes implications positives pour les actifs en or dur au cours de la
prochaine décennie et au-delà. Comment pouvons-nous vous aider?`
                      : `It is my opinion that gold valuations
                                        will see continued vitality in spite of
                                        lower volumes due to the increasing
                                        complexities of our 2021 Covid-19 and
                                        post-Covid world. Political and economic
                                        volatilities have historically driven
                                        the gold market and our world appears
                                        destined to experience these
                                        instabilities in the foreseeable future.
                                        I believe that digital payment systems,
                                        cryptocurrencies, and other
                                        non-traditional payment structures
                                        actually will have important positive
                                        implications for hard gold assets over
                                        the next decade and beyond. How may we
                                        help you?`}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <hr class="space s" />

          <p class="quote" data-aos="fade-down">
            <i class="fas fa-quote-right"></i>
            {lang === "Fr"
              ? `De toutes les matières premières, l’or est le plus rapide à négocier n’importe où, n’importe quand. – Sidi
Shahid`
              : `Of all the commodities, gold is the fastest to trade
                        anywhere, any time. – Sidi Shahid`}
          </p>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
